import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer, Notification } from 'components/';
import { Query, QueryResult } from 'react-apollo';
import * as Queries from 'api/graphql/queries';
import { AdminProductAttributeList, OrderDirection } from '@api/graphql/types';
import { RowInfo, SortingRule } from 'react-table';
import Paths from '../paths';
import { BooleanCell, OpenInNewCell } from '@components/Table/Cell';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { OperationVariables, ApolloQueryResult } from 'apollo-client';
import DeleteButton from '@components/DeleteButton';
import ReduxTable from '@components/ReduxTable';

interface StateType {
    treeData: any;
}

type Props = InjectedIntlProps & RouteComponentProps;

const ProductAttributeListDefaultOptions = {
    sortBy: {
        field: 'id',
        direction: OrderDirection.DESC,
    },
    count: 10,
    page: 0,
    filters: {},
};

const listName = 'productAttributeList';

export const ProductAttributeTypeCell = (row : any) => {
    if (row.value) {
        return <span>Igen</span>;
    }
    return <span>Nem</span>;
};

class ProductAttributeList extends React.Component<Props, StateType> {
    private defaultSorted: SortingRule[] = [{id: 'id'}];
    private refetch: ((variables?: OperationVariables | undefined) => Promise<ApolloQueryResult<AdminProductAttributeList>>) | null = null;

    private ProductAttributeTypeCell = (row : any) => {
        return <span>{this.label(`optionType.${row.value}`)}</span>;
    }

    private ActionCell = (row : any) => {
        if (row.original.id) {
            return (
                <DeleteButton
                    className="btn-xs btn-block"
                    value={row.original.id}
                    onClick={this.delete}
                />
            );
        }
        return '';
    }

    private OpenCell = OpenInNewCell((rowInfo: any) => {
        return `${Paths.productAttribute}/${rowInfo.original.code}`;
    });

    private tableColumns = [
        {Header: '', sortable: false, Cell: this.OpenCell, width: 30},
        this.getDefaultColumnByName('id'),
        this.getDefaultColumnByName('name'),
        this.getDefaultColumnByName('code'),
        this.getDefaultColumnByName('filterable', {Cell: BooleanCell}),
        this.getDefaultColumnByName('is_active', {Cell: BooleanCell}),
        this.getDefaultColumnByName('type', {Cell: this.ProductAttributeTypeCell}),
        {Cell: this.ActionCell},
    ];

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: true,
            ...options,
        };
    }

    private delete = (id: string) => {
        GraphQLClient.mutate({
            mutation: Mutations.deleteProductAttribute,
            variables: {id},
        }).then(() => {
            if (this.refetch) {
                this.refetch();
            }
            return Notification.success(this.props.intl.formatMessage({ id: 'notification.deleteSucceed' }));
        }).catch((e: any) => {
            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.productAttribute.${id}` });
    }

    private renderList(result: QueryResult<AdminProductAttributeList>) {
        if (result.loading) return null;
        if (result.error) return `Error!: ${result.error}`;

        this.refetch = result.refetch;

        if (result.data) {
            return (
                <ReduxTable
                    listName={listName}
                    defaultOptions={ProductAttributeListDefaultOptions}
                    onClick={(rowInfo: RowInfo) => {
                        this.props.history.push(`${Paths.productAttribute}/${rowInfo.original.code}`);
                    }}
                    data={result.data.adminProductAttributes}
                    columns={this.tableColumns}
                    defaultPageSize={10}
                    defaultSorted={this.defaultSorted}
                    filterable={false}
                />
            );
        }
        return null;
    }

    public render() {
        const addButton = <button className="btn btn-primary" onClick={(e: React.SyntheticEvent) => this.props.history.push(Paths.productAttributeCreate)}>Új termékparaméter</button>;

        return (
            <Drawer headerButton={addButton}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <Query query={Queries.adminProductAttributeList}>
                                    {queryResult => this.renderList(queryResult)}
                                </Query>
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

export default compose(
    withRouter,
    injectIntl,
)(ProductAttributeList);



// WEBPACK FOOTER //
// ./src/modules/ProductAttribute/pages/ProductAttributeList.tsx